<template>
    <o-section :title="label || schema.verbose_name" not-closable :level="level+1" body-classes="p-0">
        <o-item-editable-table v-model="items" :default-new-value="newChild" :form-state="formState"
            :item-name="schema.verbose_name" @change="changed">
            <template slot="o-headers">
                <th v-if="canSee(schema, 'description')">{{ schema.fields.description.label }}</th>
            </template>
            <template slot="o-body" slot-scope="{ item, index }">

                <td v-if="canSee(schema, 'description')">
                    <o-widget-wrapper :schema="schema" name="description" :validators="validators.$each[index]"
                        :server-errors="_se" :server-errors-index="index" :form-state="formState">
                        <o-text-field v-model="items[index].description" :form-state="formState" name="description"
                            :validators="validators.$each[index]" :server-errors="_se" :server-errors-index="index"
                            nolabel v-bind="schema.fields.description"></o-text-field>
                    </o-widget-wrapper>
                </td>
               
            </template>
        </o-item-editable-table>
    </o-section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import { CreateCodeTableFetchMixin, CreateFormStateMixin, CreateGroupPermissionMixin } from '../../../vue-ocom/mixins'
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";


export default {
    name: 'TermsAndConditionFormTable',
    mixins: [CreateFormStateMixin('validators'),
    CreateGroupPermissionMixin('TermsAndCondition'),
    CreateCodeTableFetchMixin([])
    ],
    components: { OItemEditableTable, OSection, },
    model: {
        prop: "items",
        event: "changed"
    },
    props: {
        items: {
            type: Array, default: () => {
            }
        },
        label: { type: String, default: null },
        validators: { type: Object, default: () => null },
        level: { type: Number, default: 0 },
    },
    data: function () {
        return {
            schemaModel: cleanUpModel(schema.TermsAndCondition, {}), /*Use this.schema instead */
            newChild: CreateDefaultItem(schema.TermsAndCondition)
        };
    },
    methods: {
        changed() {
            if (this.validator) {
                this.validator.$touch();
            }

            if (this.formState)
                this.formState.dirty = true;

            this.$emit('changed', this.items);
        }
    },
    computed: {
    },
    created() {
        // this.loadCodeTables()
    }
}
</script>